import { render } from "./Comissao.vue?vue&type=template&id=1cd3662a"
import script from "./Comissao.vue?vue&type=script&lang=js"
export * from "./Comissao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__